export const locale = {
    lang: 'fr',
    data: {
        'MENU': {
            'MY_PROFILE' : 'Mon Profil',
            'LOGOUT' : 'Se Déconnecter'
        }
    }
};